
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <Header />
    <Scroll/>

    <div class="hp_joinWrap">
      <h2 class="hp_loginTit">
        회원가입
        <p>아래 정보를 정확히 입력해 주세요.</p>
      </h2>
      <div>
        <table class="hp_tableForm" cellpadding="0" cellspacing="0" summary="회원정보">
          <caption>회원정보</caption>
          <colgroup>
            <col width="36%">
            <col width="*">
          </colgroup>
          <tbody>
            <tr v-if = "formData.customer_ID === ''">
              <th scope="row">
                <label for = 'customer_login_ID'>아이디 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  class="hp_tableInputBox"
                  type = "text"
                  id = 'customer_login_ID'
                  v-model="formData.customerLoginID"
                  maxlength="15"
                >
                <p>{{errorData.customerLoginIDError}}</p>
              </td>
            </tr>
            <tr v-if = "formData.customer_ID === ''">
              <th scope="row">
                <label for = 'customer_password'>비밀번호 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  class="hp_tableInputBox"
                  type = "password"
                  id = 'customer_password'
                  v-model="formData.customerPassword"
                  maxlength="20"
                >
                <p>{{errorData.customerPasswordError}}</p>
              </td>
            </tr>
            <tr v-if = "formData.customer_ID === ''">
              <th scope="row">
                <label for = 'customer_password_check'>비밀번호 확인 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  class="hp_tableInputBox"
                  type = "password"
                  id = 'customer_password_check'
                  v-model="formData.customerPasswordCheck"
                  maxlength="20"
                >
                <p>{{errorData.customerPasswordCheckError}}</p>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <label for = 'customer_name'>이름 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  class="hp_tableInputBox"
                  type = "text"
                  id = 'customer_name'
                  v-model="formData.customerName"
                  maxlength="10"
                >
                <p>{{errorData.customerNameError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_phone_number'>휴대전화 <span class="pointTextRed">*</span></label>
              </th>
              <td>
                <input
                  class="hp_tableInputBox"
                  type = "text"
                  id = 'customer_phone_number'
                  v-model="formData.customerPhoneNumber"
                  maxlength="13"
                >
                <p>{{errorData.customerPhoneNumberError}}</p>
              </td>
            </tr>
            <tr>
              <th>
                <label for = 'customer_email'>이메일</label>
              </th>
              <td>
                <input
                  class="hp_tableInputBox"
                  type = "text"
                  id = 'customer_email'
                  v-model="formData.customerEmail"
                  maxlength="50"
                >
                <p>{{errorData.customerEmailError}}</p>
              </td>
            </tr>

            <tr>
              <th>
                마케팅 동의
              </th>
              <td>
                <div class="hp_tableInputCheckTD">
                  <input
                    class="hp_tableInputCheck"
                    type = "checkbox"
                    id = 'customer_marketing_status'
                    v-model="formData.customerMarketingStatus"
                  >
                  <label class="hp_tableInputCheck_label" for = 'customer_marketing_status'> 마케팅 수신에 동의합니다</label>
                </div>
              </td>
            </tr>
            <tr>
                <th>
                  <label for = 'security_code'>보안코드</label>
                </th>
                <td>
                  <div class="securityTxt">{{statusData.securityCode}}</div>
                  <input
                    type = "text"
                    class="hp_tableInputBox"
                    id = 'security_code'
                    v-model="formData.securityCode"
                    maxlength="4"
                  >
                  <p>{{errorData.securityCodeError}}</p>
                </td>
              </tr>
          </tbody>
        </table>
      </div>

      <div class="hp_commuDetail_privacyBox"> <!-- 댓글 작성 약관 동의 -->
        <div class="hp_commuDetail_pbAll">
          <input  type="checkbox" id="agreeAll" v-model="formData.agreeAll" @change="toggleAllAgreements" />
          <label for="agreeAll">이용약관 및 개인정보방침에 모두 동의합니다.</label>
        </div>
        <div class="hp_commuDetail_pbEarch">
          <div>
            <input type="checkbox" id="agree4" v-model="formData.agree4" @change="checkIndividualAgreements" />
            <label for="agree4"><span>[필수]</span> 서비스 이용약관에 동의</label>
          </div>
          <button type="button" @click="togglePopup(4)">약관보기</button>
        </div>
        <div class="hp_commuDetail_pbEarch">
          <div>
            <input type="checkbox" id="agree1" v-model="formData.agree1" @change="checkIndividualAgreements" />
            <label for="agree1"><span>[필수]</span> 수집하는 개인정보의 항목에 동의</label>
          </div>
          <button type="button" @click="togglePopup(1)">약관보기</button>
        </div>
        <div class="hp_commuDetail_pbEarch">
          <div>
            <input type="checkbox" id="agree2" v-model="formData.agree2" @change="checkIndividualAgreements" />
            <label for="agree2"><span>[필수]</span> 개인정보의 수집 이용목적에 동의</label>
          </div>
          <button type="button" @click="togglePopup(2)">약관보기</button>
        </div>
        <div class="hp_commuDetail_pbEarch">
          <div>
            <input type="checkbox" id="agree3" v-model="formData.agree3" @change="checkIndividualAgreements" />
            <label for="agree3"><span>[필수]</span> 개인정보의 보유 및 이용기간에 동의</label>
          </div>
          <button type="button" @click="togglePopup(3)">약관보기</button>
        </div>
      </div>
      <button class="hp_loginBtn" v-on:click="check_form">가입하기</button>
    </div>
    <PopupComponent
      :isVisible="statusData.isPopupVisible"
      :toggleStatus="statusData.toggleStatus"
      @update:isVisible="statusData.isPopupVisible = $event"
    />
    <Footer />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import Spiner from '../Section/Spiner.vue'
import PopupComponent from '../Section/PopupComponent.vue'
import { ref } from 'vue'
import {
  removeWhitespace,
  validateEngNum,
  validatePassword,
  validateKorEng,
  removeWhitespacePhone,
  validatePhone,
  validateEmail
} from '../../ETC/Validation.vue'
import {
  check_customer_login_ID,
  insert_customer_management,
  update_customer_easy_join_management,
  check_login
} from '../../ETC/Axios.vue'

export default {
  name: 'Join',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll,
    Spiner,
    PopupComponent
  },
  setup () {
    return {
      formData: ref({
        customer_ID: '',
        customerLoginID: '',
        customerPassword: '',
        customerPasswordCheck: '',
        customerName: '',
        customerPhoneNumber: '',
        customerEmail: '',
        customerMarketingStatus: false,
        agreeAll: false,
        agree1: false,
        agree2: false,
        agree3: false,
        agree4: false,
        securityCode: ''
      }),
      errorData: ref({
        customerLoginIDError: '아이디는 필수 입력입니다.',
        customerPasswordError: '비밀번호는 필수 입력입니다.',
        customerPasswordCheckError: '비밀번호 확인은 필수 입력입니다.',
        customerNameError: '이름은 필수 입력입니다.',
        customerPhoneNumberError: '휴대전화는 필수 입력입니다.',
        customerEmailError: '',
        securityCodeError: ''
      }),
      statusData: ref({
        customerLoginStatus: false,
        customerPasswordStatus: false,
        customerPasswordCheckStatus: false,
        customerNameStatus: false,
        customerPhoneNumberStatus: false,
        customerEmailStatus: true,
        spinnerStatus: false,
        toggleStatus: 1,
        isPopupVisible: false,
        securityCode: ''
      })
    }
  },
  methods: {
    generateSecurityCode () {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      this.statusData.securityCode = result
    },
    togglePopup (toggleStatus) {
      this.statusData.toggleStatus = toggleStatus
      this.statusData.isPopupVisible = !this.statusData.isPopupVisible
    },
    toggleAllAgreements () {
      this.formData.agree1 = this.formData.agreeAll
      this.formData.agree2 = this.formData.agreeAll
      this.formData.agree3 = this.formData.agreeAll
      this.formData.agree4 = this.formData.agreeAll
    },
    checkIndividualAgreements () {
      if (this.formData.agree1 && this.formData.agree2 && this.formData.agree3 && this.formData.agree4) {
        this.formData.agreeAll = true
      } else {
        this.formData.agreeAll = false
      }
    },
    check_form: function () {
      const { agree1, agree2, agree3 } = this.formData
      if (!agree1 || !agree2 || !agree3) {
        alert('개인정보동의를 체크해야 합니다.')
      } else if (this.formData.agree4 === false) {
        alert('서비스 이용동의를 체크해야 합니다.')
      } else if (this.formData.securityCode !== this.statusData.securityCode) {
        alert('보안 코드가 일치하지 않습니다.')
      } else if (
        this.statusData.customerLoginStatus &&
        this.statusData.customerPasswordStatus &&
        this.statusData.customerPasswordCheckStatus &&
        this.statusData.customerNameStatus &&
        this.statusData.customerPhoneNumberStatus &&
        this.statusData.customerEmailStatus
      ) {
        this.statusData.spinnerStatus = true
        if (this.formData.customer_ID === '') {
          insert_customer_management(
            this.formData.customerLoginID,
            this.formData.customerPassword,
            this.formData.customerName,
            this.formData.customerPhoneNumber,
            this.formData.customerEmail,
            this.formData.agree1,
            this.formData.agree4,
            this.formData.customerMarketingStatus
          ).then(result => {
            if (result === 1) {
              check_login(
                this.formData.customerLoginID,
                this.formData.customerPassword
              ).then(result => {
                if (result === 1) {
                  alert('등록 및 로그인이 완료되었습니다.')
                  if (this.$route.query.reser_status) {
                    this.$router.push({path: '/Reservation'})
                  } else {
                    this.$router.push('/')
                  }
                }
              })
            } else {
              this.statusData.spinnerStatus = false
              alert('등록 중 에러가 발생되었습니다. 관리자한테 문의해주세요.')
            }
          })
        } else {
          update_customer_easy_join_management(
            this.formData.customer_ID,
            this.formData.customerName,
            this.formData.customerPhoneNumber,
            this.formData.customerEmail,
            this.formData.agree1,
            this.formData.agree4,
            this.formData.customerMarketingStatus
          ).then(result => {
            this.statusData.spinnerStatus = false
            alert('등록 및 로그인이 완료되었습니다.')
            this.$router.push('/')
          })
        }
      } else {
        alert('입력사항을 확인하셔야 합니다.')
      }
    }
  },
  watch: {
    'formData.customerLoginID': function (value) {
      this.formData.customerLoginID = removeWhitespace(value)
      check_customer_login_ID(removeWhitespace(value)).then(result => {
        if (result === 0) {
          if (removeWhitespace(value) === '') {
            this.errorData.customerLoginIDError = '아이디는 필수로 입력해야 합니다.'
            this.statusData.customerLoginStatus = false
          } else if (removeWhitespace(value).length < 5) {
            this.errorData.customerLoginIDError = '아이디는 최소 6자이상 입력해야 합니다.'
            this.statusData.customerLoginStatus = false
          } else if (validateEngNum(removeWhitespace(value))) {
            this.errorData.customerLoginIDError = ''
            this.statusData.customerLoginStatus = true
          } else {
            this.errorData.customerLoginIDError = '한글 및 특수문자는 입력할 수 없습니다.'
            this.statusData.customerLoginStatus = false
          }
        } else {
          this.errorData.customerLoginIDError = '중복된 아이디가 있습니다.'
          this.statusData.customerLoginStatus = false
        }
      })
    },
    'formData.customerPassword': function (value) {
      this.formData.customerPassword = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordError = '비밀번호는 필수 입력입니다.'
        this.statusData.customerPasswordStatus = false
      } else if (validatePassword(removeWhitespace(value))) {
        this.errorData.customerPasswordError = ''
        this.statusData.customerPasswordStatus = true
      } else {
        this.errorData.customerPasswordError = '영문, 숫자, 특수문자를 혼합하여 8~20자까지 입력해야 합니다.'
        this.statusData.customerPasswordStatus = false
      }
    },
    'formData.customerPasswordCheck': function (value) {
      this.formData.customerPasswordCheck = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerPasswordCheckError = '비밀번호 확인은 필수로 입력해야 합니다.'
        this.statusData.customerPasswordCheckStatus = false
      } else if (this.formData.customerPassword === value) {
        this.errorData.customerPasswordCheckError = ''
        this.statusData.customerPasswordCheckStatus = true
      } else {
        this.errorData.customerPasswordCheckError = '비밀번호가 일치하지 않습니다.'
        this.statusData.customerPasswordCheckStatus = false
      }
    },
    'formData.customerName': function (value) {
      this.formData.customerName = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerNameError = '이름은 필수로 입력해야 합니다.'
        this.statusData.customerNameStatus = false
      } else if (removeWhitespace(value).length < 2) {
        this.errorData.customerNameError = '이름은 최소 2자이상 입력해야 합니다.'
        this.statusData.customerNameStatus = false
      } else if (validateKorEng(removeWhitespace(value))) {
        this.errorData.customerNameError = ''
        this.statusData.customerNameStatus = true
      } else {
        this.errorData.customerNameError = '한글 및 영문만 입력해야 합니다.'
        this.statusData.customerNameStatus = false
      }
    },
    'formData.customerPhoneNumber': function (value) {
      const cleanValue = value.replace(/\D/g, '')
      this.formData.customerPhoneNumber = removeWhitespacePhone(cleanValue)
      if (removeWhitespacePhone(value) === '') {
        this.errorData.customerPhoneNumberError = '휴대전화는 필수로 입력해야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      } else if (validatePhone(removeWhitespacePhone(value))) {
        this.errorData.customerPhoneNumberError = ''
        this.statusData.customerPhoneNumberStatus = true
      } else {
        this.errorData.customerPhoneNumberError = '휴대전화 형식으로 입력해야 합니다.'
        this.statusData.customerPhoneNumberStatus = false
      }
    },
    'formData.customerEmail': function (value) {
      this.formData.customerEmail = removeWhitespace(value)
      if (removeWhitespace(value) === '') {
        this.errorData.customerEmailError = ''
        this.statusData.customerEmailStatus = true
      } else if (validateEmail(removeWhitespace(value))) {
        this.errorData.customerEmailError = ''
        this.statusData.customerEmailStatus = true
      } else {
        this.errorData.customerEmailError = '이메일 형식으로 입력해야 합니다.'
        this.statusData.customerEmailStatus = false
      }
    }
  },
  mounted () {
    if (this.$route.query.customer_ID) {
      this.formData.customer_ID = this.$route.query.customer_ID
      this.formData.customerEmail = this.$route.query.customer_email
      this.formData.customerName = this.$route.query.customer_name
      this.statusData.customerLoginStatus = true
      this.statusData.customerPasswordStatus = true
      this.statusData.customerPasswordCheckStatus = true
    }
    this.generateSecurityCode()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Join/Join.vue